import { render, staticRenderFns } from "./InventoryMain.vue?vue&type=template&id=a00d443c&scoped=true"
import script from "./InventoryMain.vue?vue&type=script&lang=js"
export * from "./InventoryMain.vue?vue&type=script&lang=js"
import style0 from "./InventoryMain.vue?vue&type=style&index=0&id=a00d443c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00d443c",
  null
  
)

export default component.exports